import React from "react";
import { Container, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Header from "./Header";
import Footer from "./Footer";
import SideBanner from "./SideBanner";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "0px 0px 0px 30px",
    border: "2px solid #000"
  },
  content: {
    position: "relative",
    zIndex: theme.zIndex.content,
    paddingBottom: theme.spacing(2),
    [theme.breakpoints.up("md")]: {
      display: "grid",
      gridTemplate: "min-content auto min-content / 1fr",
      minHeight: "100vh",
      paddingBottom: 0,
      margin: "auto",
      [theme.breakpoints.up("md")]: {
        maxWidth: "600px",
      },
      [theme.breakpoints.up("lg")]: {
        maxWidth: "900px",
      },
    },
  },
  title: {
    fontWeight: 600,
    color: theme.palette.text.primary,
    opacity: 0.6,
  },
  stepContainer: {
    width: "100%",
    margin: theme.spacing(0, "auto"),
    zIndex: 100,
    [theme.breakpoints.up("md")]: {
      maxWidth: "600px",
    },
    [theme.breakpoints.up("lg")]: {
      maxWidth: "900px",
    },
  },
}));

const Layout = ({ children }) => {
  const classes = useStyles();

  return (
    <>
      <SideBanner />
      <Container className={classes.root} maxWidth={false}>
        <div className={classes.content}>
          <Header />

          <Box className={classes.stepContainer}>
            {children}
          </Box>

          <Footer />
        </div>
      </Container>
    </>
  );
};

export default Layout;
